import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
  id: 'POOL',
  analyticsName: 'Pool',
  queryKey: 'f_pool',
  type: FILTER_TYPES.BOOLEAN,
  bucketify: (hotel) => {
    const facts = hotel?.hotelFacts;

    if (!facts?.length) {
      return {
        bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
        bucketName: 'pool',
      };
    }

    for (let i = 0; i < facts.length; i += 1) {
      const fact = facts[i];

      if (fact && fact.id === 'pools') {
        return {
          bucketId: fact.filterValue ? FILTER_TYPES.BINARY_BUCKET.TRUE : FILTER_TYPES.BINARY_BUCKET.FALSE,
          bucketName: 'pool',
        };
      }
    }

    return {
      bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
      bucketName: 'pool',
    };
  },
  toQuery: ({ value }) => {
    return value ? 1 : undefined;
  },
  fromQuery: (rawQueryValue) => {
    return {
      [FILTER_TYPES.BINARY_BUCKET.TRUE]: !!rawQueryValue,
    };
  },
}));
